import { useState } from "react";
import type { CanvasDocumentV3 } from "@seedance/contracts";
import { createEditorRequestPreviewBuilder, type EditorRequestPreviewBuilder } from "../panels/RequestPreviewPanel.js";

/** React owns the previous render's baseline. A speculative render must not
 * publish a new document into a shared ref; discarding reuse is always safe. */
export function useRequestPreviewBuilder(document: CanvasDocumentV3): EditorRequestPreviewBuilder {
  const [previous, setPrevious] = useState(() => createEditorRequestPreviewBuilder(document));
  if (previous.document !== document) {
    const current = createEditorRequestPreviewBuilder(document, previous);
    setPrevious(current);
    return current;
  }
  return previous;
}
